import axios from 'axios'
import {UseCollaboratorModel, UseCollaboratorFilterModel, ResponseObject} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getUserCollaborator(dto: UseCollaboratorFilterModel) {
  return axios.post<ResponseObject<UseCollaboratorModel[]>>(
    `${BASEURL}/order/getResponsableColaborador?size=100`,
    dto,
  )
}
